module.exports = require("css.escape");